import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Panel } from "@/components/KpiCard";
import { PreuvesBooking } from "@/components/PreuvesBooking";
import { api, errMsg } from "@/lib/api";

export const BookingTaxePanel = () => {
  const [actif, setActif] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings").then((r) => setActif(!!r.data.booking_remet_taxe)).catch((e) => toast.error(errMsg(e))); }, []);
  if (actif === null) return <Loader2 className="h-5 w-5 animate-spin text-emerald-700" />;
  const changer = async (v) => {
    setBusy(true);
    try { await api.put("/settings/booking-remet-taxe", { actif: v }); setActif(v); toast.success(v ? "Taxe Booking exclue de vos remises" : "Taxe Booking incluse dans vos remises"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Panel title="Taxe de séjour Booking" testId="booking-taxe-panel">
      <label className="flex items-start gap-3 cursor-pointer">
        <Switch checked={actif} onCheckedChange={changer} disabled={busy} data-testid="booking-remet-taxe-switch" />
        <span className="text-sm text-slate-800">Booking remet la taxe sur l'hébergement (3,5 %) à Revenu Québec</span>
      </label>
      <p className="mt-2 text-[11px] text-slate-500" data-testid="booking-taxe-aide">
        Si activé, la taxe de séjour de toutes vos réservations Booking est retirée du montant « à remettre » dans le bilan, le PDF et les déclarations trimestrielles. À activer seulement si votre compte Booking confirme qu'il perçoit et remet cette taxe pour vous.
      </p>
      <PreuvesBooking actif={actif} />
    </Panel>
  );
};
